import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Dialog as MuiDialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withTheme, useTheme } from 'emotion-theming';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import Flex from '../Flex';
import Text from '../Text';
import DialogCloseButton from './DialogCloseButton';
import { color, space, border, layout, compose } from 'styled-system'; // We need to pass this in to override the MUI Paper component's default styles via PaperProps

import themeGet from '@styled-system/theme-get';

var getContainerStyle = function getContainerStyle(maxWidth, themeContext) {
  var widths = themeGet('sizes.dialogWidths', {
    sm: 440
  })({
    theme: themeContext
  }); // If value cannot be found in the theme object, just pass the number

  var maxW = widths[maxWidth] || maxWidth;
  return {
    width: maxW,
    maxWidth: maxW
  };
};

var Dialog = function Dialog(props) {
  var title = props.title,
      onClose = props.onClose,
      hideCloseButton = props.hideCloseButton,
      children = props.children,
      ariaDescribedBy = props.ariaDescribedBy,
      ariaLabelledBy = props.ariaLabelledBy,
      fullScreen = props.fullScreen,
      isOpen = props.isOpen,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      onEnter = props.onEnter,
      maxWidth = props.maxWidth,
      dataTestid = props['data-testid'];
  var themeContext = useTheme();

  var _useState = useState(uniqueId('ads-modal-')),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var closeButtonLabelId = "".concat(id, "-close");
  var classes = makeStyles({
    paper: _extends({}, compose(space, color, border, layout)(props))
  }, {
    name: 'Dialog'
  })();
  /*
    Note that below we cannot affect the Dialog's maxWidth 
    due to the way that MUI applies these values. Instead, 
    we need to do it ourselves via the style prop applied 
    to PaperProps.
  */

  return React.createElement(MuiDialog, {
    "data-testid": dataTestid,
    "aria-labelledby": ariaLabelledBy || id,
    "aria-describedby": ariaDescribedBy,
    style: {
      flexShrink: 1
    },
    open: isOpen,
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    fullScreen: fullScreen,
    onEnter: onEnter,
    PaperProps: {
      className: classes.paper,
      style: _extends({
        background: 'transparent',
        boxShadow: 'none',
        borderRadius: 0
      }, fullScreen ? {} : getContainerStyle(maxWidth, themeContext))
    },
    onClose: onClose
  }, React.createElement(Flex, {
    width: "100%",
    height: "100%",
    p: 2,
    backgroundColor: "background",
    boxShadow: "large",
    borderRadius: fullScreen ? 0 : 'small',
    flexDirection: "column"
  }, React.createElement(Flex, {
    alignItems: "flex-start",
    justifyContent: "flex-end"
  }, title && React.createElement(Text, {
    id: id,
    mb: 2,
    mr: 2,
    flex: 1,
    variant: "h5",
    fontWeight: "bold",
    color: "text"
  }, title), !hideCloseButton && React.createElement(DialogCloseButton, {
    "aria-labelledby": closeButtonLabelId,
    onClick: onClose
  })), React.createElement(Flex, {
    direction: "column",
    color: "text"
  }, children)));
};

Dialog.defaultProps = {
  maxWidth: 'sm',
  bg: 'transparent',
  boxShadow: 'none',
  borderRadius: 0
};
export default withTheme(Dialog);